 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import { DayPicker} from 'react-day-picker'
import {useFragment} from 'react-relay'
import useAtmosphere from '../hooks/useAtmosphere'

import useMutationProps from '../hooks/useMutationProps'

import UpdateTaskDueDateMutation from '../mutations/UpdateTaskDueDateMutation'
import {PALETTE} from '../styles/paletteV3'

import Menu from './Menu'







const TallMenu = styled(Menu)({
  maxHeight: 360
})

const PickerTitle = styled('div')({
  fontSize: 14,
  paddingTop: 8,
  textAlign: 'center',
  userSelect: 'none',
  width: '100%'
})

const Hint = styled('div')({
  fontSize: 11,
  color: PALETTE.SLATE_600,
  textAlign: 'center'
})

const DueDatePicker = (props) => {
  const {menuProps, task: taskRef, useTaskChild} = props
  const task = useFragment(
    graphql`
      fragment DueDatePicker_task on Task {
        id
        dueDate
      }
    `,
    taskRef
  )
  const {id: taskId, dueDate} = task
  useTaskChild('dueDate')
  const atmosphere = useAtmosphere()
  const {onCompleted, onError, submitMutation, submitting} = useMutationProps()
  const handleDayClick = (day, {disabled, selected}) => {
    if (disabled || submitting) return
    submitMutation()
    const dueDate = selected ? null : day
    UpdateTaskDueDateMutation(atmosphere, {taskId, dueDate}, {onCompleted, onError})
    menuProps.closePortal()
    ;_optionalChain([(document ), 'access', _ => _.activeElement, 'optionalAccess', _2 => _2.blur, 'call', _3 => _3()])
  }

  const selectedDate = dueDate ? new Date(dueDate) : undefined
  const showHint = false
  const now = new Date()
  const nextYear = new Date(new Date().setFullYear(now.getFullYear() + 1))
  return (
    React.createElement(TallMenu, { ariaLabel: "Pick a due date"   , ...menuProps,}
      , React.createElement(React.Fragment, null
        , React.createElement(PickerTitle, null, 'Change Due Date')
        , showHint && React.createElement(Hint, null, 'To remove, tap selected date')
        , React.createElement(DayPicker, {
          disabled: {before: now},
          fromMonth: now,
          defaultMonth: selectedDate || now,
          onDayClick: handleDayClick,
          selected: selectedDate,
          toMonth: nextYear,}
        )
      )
    )
  )
}

export default DueDatePicker
